import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Paper } from "@mui/material";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import { baseUrl, requestID, config } from "../../../common/utils";

const AddPosition = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const electionIdFromQuery = queryParams.get("electionId");

  const [form, setForm] = useState({
    election_id: "",
    position_name: "",
  });

  useEffect(() => {
    if (electionIdFromQuery) {
      setForm((prev) => ({ ...prev, election_id: electionIdFromQuery }));
    }
  }, [electionIdFromQuery]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const history = useHistory();

  const onManage = (id: string) => {
    history.push(`/folder/manage-election/${id}`, { state: { dataId: id } });
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("election_id", form.election_id);
    formData.append("position_name", form.position_name);

 /*    console.log("FormData:");
    for (const [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
 */
    axios
      .post(baseUrl() + "elections/addPosition", formData, config)
      .then((res) => {
        alert("Position added successfully");
        setForm({ election_id: electionIdFromQuery || "", position_name: "" });
        console.log(res);
        onManage(form.election_id);
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to add position");
      });
  };

  return (
    <Paper sx={{ p: 3, mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        Add Position
      </Typography>
      <TextField
        label="Election ID"
        name="election_id"
        fullWidth
        margin="normal"
        value={form.election_id}
        onChange={handleChange}
        disabled
      />
      <TextField
        label="Position Name"
        name="position_name"
        fullWidth
        margin="normal"
        value={form.position_name}
        onChange={handleChange}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        sx={{ mt: 2 }}
      >
        Add Position
      </Button>
    </Paper>
  );
};

export default AddPosition;
